module.exports = __webpack_public_path__ + "static/media/branch-detail-1800.4f9baffb.jpg";